<style lang="scss" scoped>
.day-configurator-practical-details {
    background-color: #fff;
    width: 80px;
    box-shadow: inset -1px 0 0 #e4e4e4;
    overflow: hidden;
    transition: width 0.3s, transform 0.3s, padding 0.3s;
    position: absolute;
    height: calc(100vh - 65px);
    height: calc(var(--vh, 1vh) * 100 - 65px);
    left: 0;
    transform: translateX(-100%) translateX(80px);
    z-index: 1;
    -ms-overflow-style: none;

    @media screen and (max-width: 767.98px) {
        width: 100vw;
        transform: translateX(-100%);
    }

    width: 100%;
    overflow-y: scroll;
    transform: none;

    @media screen and (min-width: 768px) {
        width: 400px;
    }

    .form-wrapper {
        width: 100%;
        transition: opacity 0.3s, visibility 0s 0s;

        @media screen and (min-width: 768px) {
            width: 320px;
        }
    }

    .icon-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 80px;
        height: 100%;

        opacity: 1;
        visibility: visible;
        transition: opacity 0.3s, visibility 0s 0s;

        a {
            display: block;
            position: relative;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            transition: background-color 0.2s;

            ::v-deep .icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                transition: width 0.2s, height 0.2s;

                path {
                    transition: stroke 0.2s;
                }
            }

            &:hover {
                cursor: pointer;
            }

            &.active,
            &:hover {
                background-color: rgba(243, 146, 37, 0.16);

                ::v-deep .icon {
                    width: 13px;
                    height: 12px;

                    path {
                        stroke: var(--accent);
                    }
                }
            }
        }
    }

    .kilometers {
        display: block;
        height: 30px;
        padding: 0;
        line-height: 30px;
    }

    .spinner-background {
        display: block;
        opacity: 0;
        transition: opacity 0.5s;
        pointer-events: none;
        width: 72px;

        &.visible {
            opacity: 1;
        }

        .spinner {
            width: 16px;
            height: 16px;
            &:before {
                left: -28px;
                width: 16px;
                height: 16px;
            }
            &:after {
                left: 28px;
                width: 16px;
                height: 16px;
            }
        }
    }

    ::v-deep .flatpickr-calendar {
        @media screen and (max-width: 767.98px) {
            margin-left: auto;
            margin-right: auto;
        }
    }

    #range {
        width: 78px;
    }

    #amount_of_persons {
        padding: 0;
    }

    .increase,
    .decrease {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
    }

    .btn {
        @media screen and (max-width: 767.98px) {
            padding: 20px 16px !important;
        }
    }
}
</style>

<template>
    <div
        class="day-configurator-practical-details px-24 pt-24 pb-0 px-md-40 py-md-32"
    >
        <div class="content-wrapper">
            <div class="form-wrapper">
                <ValidationObserver
                    v-slot="{ invalid, errors }"
                    tag="div"
                    :slim="true"
                    ref="observer"
                >
                    <h2 class="mb-24 mb-md-32">
                        {{ translations.practical_details.title }}
                    </h2>

                    <label for="date" class="mb-16">{{
                        translations.practical_details.date
                    }}</label>
                    <p class="mb-16 font-weight-light">
                        {{ translations.practical_details.date_description }}
                    </p>
                    <div class="mb-40 mb-md-24">
                        <div class="date-wrapper mb-0">
                            <ValidationProvider
                                ref="provider"
                                vid="date"
                                name="date"
                                :rules="
                                    schedule.date_object != null &&
                                    schedule.date_object.type === 'unknown'
                                        ? ''
                                        : 'required'
                                "
                                tag="div"
                            >
                                <flat-pickr
                                    :allowInput="false"
                                    v-on="{ ...$listeners, input: dateUpdate }"
                                    id="date"
                                    name="date"
                                    v-model="flatPickrDate"
                                    :config="flatPickrConfig"
                                ></flat-pickr>
                            </ValidationProvider>
                        </div>
                        <span
                            v-if="
                                schedule.date_object != null &&
                                    schedule.date_object.type !== 'single'
                            "
                            class="d-inline-block mr-8"
                            >{{ dateMode }}</span
                        ><a
                            href="#"
                            @click.prevent="showDatePopup()"
                            class="text-accent font-weight-light"
                            >{{
                                schedule.date_object == null ||
                                schedule.date_object.type === "single"
                                    ? translations.practical_details
                                          .no_exact_date_label
                                    : translations.practical_details.modify
                            }}</a
                        >
                    </div>

                    <label for="location" class="mb-16">{{
                        translations.practical_details.location
                    }}</label>

                    <div
                        class="spinner-background visible mb-24"
                        v-if="
                            !items.location ||
                                !items.location.length ||
                                loadingGoogleLocation
                        "
                    >
                        <div class="spinner"></div>
                    </div>
                    <template v-else>
                        <p class="mb-16 font-weight-light">
                            Maak een keuze uit onze lijst met inspirerende
                            locaties. Meer weten over de locaties? Klik dan
                            <a :href="route('nl.locations')" target="_blank"
                                >hier</a
                            >. Liever ergens anders? Klik dan op 'Meer opties'.
                        </p>
                        <ValidationProvider
                            v-if="location_type === 'WORDPRESS'"
                            ref="location"
                            vid="location"
                            class="mb-24"
                            :name="translations.practical_details.location"
                            rules="required"
                            tag="div"
                        >
                            <el-input
                                v-model="location"
                                :options="items.location.map(l => l.post_title)"
                                type="select"
                                rules="required"
                                name="location"
                                :placeholder="
                                    translations.practical_details
                                        .location_choose
                                "
                                vid="location"
                            />
                        </ValidationProvider>

                        <template v-else-if="location_type === 'GOOGLE_MAPS'">
                            <div class="d-flex mb-8">
                                <ValidationProvider
                                    ref="location"
                                    vid="location"
                                    class="w-100"
                                    :name="
                                        translations.practical_details.location
                                    "
                                    rules="required"
                                    tag="div"
                                    v-slot="{ classes }"
                                >
                                    <vue-google-autocomplete
                                        ref="locationAutocomplete"
                                        id="location"
                                        name="location"
                                        :types="''"
                                        :class="classes"
                                        :placeholder="
                                            translations.practical_details
                                                .location_choose
                                        "
                                        :country="['be']"
                                        v-on:placechanged="getAddressData"
                                        v-on:blur="validateAddress"
                                        v-on:change="validateAddress"
                                    ></vue-google-autocomplete>
                                </ValidationProvider>
                                <ValidationProvider
                                    ref="range"
                                    vid="range"
                                    :name="
                                        translations.practical_details
                                            .location_range
                                    "
                                    rules="integer|min:1|max:300"
                                    v-slot="{ classes }"
                                    tag="div"
                                >
                                    <input
                                        type="number"
                                        id="range"
                                        class="ml-16"
                                        :class="classes"
                                        :name="
                                            translations.practical_details
                                                .location_range
                                        "
                                        min="1"
                                        max="300"
                                        v-model="radius"
                                        :placeholder="
                                            translations.practical_details
                                                .location_range
                                        "
                                    />
                                </ValidationProvider>
                                <span class="kilometers ml-8 font-weight-light"
                                    >km</span
                                >
                            </div>
                            <span
                                v-if="
                                    (errors.location != null &&
                                        errors.location.length > 0) ||
                                        (errors.range != null &&
                                            errors.range.length > 0)
                                "
                                class="error small d-block mb-24"
                                >{{
                                    errors.location[0] || errors.range[0]
                                }}</span
                            >
                        </template>
                        <a
                            href="#"
                            @click.prevent="showLocationPopup()"
                            class="d-inline-block text-accent font-weight-light mb-24"
                            >Meer opties</a
                        >
                    </template>

                    <div
                        class="d-flex justify-content-between align-items-center"
                        :class="
                            errors.amount_of_persons != null &&
                            errors.amount_of_persons.length > 0
                                ? 'mb-8'
                                : 'mb-32'
                        "
                    >
                        <div class="d-flex flex-column w-100">
                            <label for="amount_of_persons" class="mb-8">{{
                                translations.practical_details.amount_of_persons
                            }}</label>
                            <a
                                href="#"
                                @click.prevent="showParticipantsPopup()"
                                class="text-accent font-weight-light"
                                >{{
                                    attendee_object.type === "exact"
                                        ? translations.practical_details
                                              .amount_of_persons_unknown
                                        : translations.practical_details.modify
                                }}</a
                            >
                        </div>

                        <div
                            class="number-wrapper d-flex align-items-center"
                            v-if="attendee_object.type === 'exact'"
                        >
                            <span
                                class="decrease mr-16"
                                @click="decreaseParticipants"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="10"
                                >
                                    <path
                                        fill="#efefef"
                                        d="M5 10A5 5 0 105 0a5 5 0 000 10z"
                                    />
                                    <path
                                        d="M7.1 4.6a.4.4 0 01.08.792L7.1 5.4H2.9a.4.4 0 01-.08-.792L2.9 4.6z"
                                    />
                                </svg>
                            </span>
                            <ValidationProvider
                                ref="provider"
                                vid="amount_of_persons"
                                class="w-100"
                                :name="
                                    translations.practical_details
                                        .amount_of_persons
                                "
                                :rules="
                                    attendee_object.type === 'exact'
                                        ? 'required|integer|min:1'
                                        : ''
                                "
                                tag="div"
                            >
                                <input
                                    type="number"
                                    id="amount_of_persons"
                                    min="1"
                                    name="amount_of_persons"
                                    class="text-center"
                                    v-model="attendee_object.data.amount"
                                />
                            </ValidationProvider>
                            <span
                                class="increase ml-16"
                                @click="increaseParticipants"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="10"
                                >
                                    <path
                                        fill="#efefef"
                                        d="M5 10A5 5 0 105 0a5 5 0 000 10z"
                                    />
                                    <path
                                        d="M5 2.5a.4.4 0 01.392.32l.008.08v1.7h1.7a.4.4 0 01.08.792L7.1 5.4H5.4v1.7a.4.4 0 01-.792.08L4.6 7.1V5.4H2.9a.4.4 0 01-.08-.792L2.9 4.6h1.7V2.9c0-.22.18-.4.4-.4z"
                                    />
                                </svg>
                            </span>
                        </div>

                        <div v-else>
                            <label>{{
                                `${attendee_object.data.min}&#8209;${
                                    attendee_object.data.max
                                }${
                                    attendee_object.data.max == 300 ? "+" : ""
                                }&nbsp;${
                                    translations.practical_details.persons
                                }`
                            }}</label>
                        </div>
                    </div>

                    <span
                        v-if="
                            errors.amount_of_persons != null &&
                                errors.amount_of_persons.length > 0
                        "
                        class="error small d-block mb-24"
                        >{{ errors.amount_of_persons[0] }}</span
                    >
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
var cloneDeep = require("lodash.clonedeep");
import core from "./day-configurator-core";

import flatPickr from "vue-flatpickr-component";
import { Dutch } from "flatpickr/dist/l10n/nl.js";

import DateModal from "./modals/day-configurator-date-modal";
import ParticipantModal from "./modals/day-configurator-participant-modal";
import LocationModal from "./modals/day-configurator-location-modal";

import { ValidationObserver, ValidationProvider, validate } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import nl from "vee-validate/dist/locale/nl.json";
for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: nl.messages[rule]
    });
}

import { bus } from "@/app";

export default {
    mixins: [core],

    components: { ValidationObserver, ValidationProvider, flatPickr },

    props: {
        items: {
            type: Object,
            required: true
        },
        loadingGoogleLocation: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({
        location: null,
        location_type: "WORDPRESS",
        radius: null,
        flatPickrDate: "",
        attendee_object: {
            type: "exact",
            data: {
                amount: 10
            }
        },

        flatPickrConfig: {
            locale: Dutch,
            mode: "single",
            inline: true,
            minDate: new Date(),
            dateFormat: "Y-m-d"
        }
    }),

    mounted() {
        var self = this;
        self.readSchedule();

        bus.$on("dateUpdate", date_object => {
            self.setFlatpickrMode(date_object);
            let oldDateString = self.flatPickrDate;
            self.flatPickrDate = self.dateToString(date_object);
            if (self.flatPickrDate === oldDateString) self.dateUpdate(); // Trigger manually when date string didn't change
        });

        bus.$on("attendeeUpdate", attendee_object => {
            let attendee_clone = cloneDeep(attendee_object);
            self.attendee_object = attendee_clone;
            self.attendeeUpdate();
        });

        bus.$on("addressUpdate", address => {
            self.$nextTick().then(() => {
                let locationInput = document.querySelector("#location");

                if (locationInput) {
                    locationInput.value = address;
                } else {
                    let observer = new MutationObserver(
                        (mutations, observer) => {
                            let locationInput = document.querySelector(
                                "#location"
                            );
                            if (locationInput) {
                                locationInput.value = address;
                                observer.disconnect(); // Stop observing when the input is found
                            }
                        }
                    );

                    observer.observe(document, {
                        childList: true,
                        subtree: true
                    });
                }
            });
        });

        bus.$on("locationUpdate", location_object => {
            self.location = location_object.location;
            self.location_type = location_object.location_type;
            self.radius =
                location_object.location_type === "WORDPRESS"
                    ? null
                    : location_object.radius;

            if (location_object.location_type === "GOOGLE_MAPS") {
                self.prefillLocationField(location_object.location);
            }

            self.locationUpdate();
        });
    },

    methods: {
        readSchedule() {
            let schedule = cloneDeep(
                this.$store.getters["dayConfigurator/schedule"]
            );

            if (schedule.public_key != null) {
                this.location = schedule.location;
                this.location_type = schedule.location_type;
                this.radius = schedule.radius;
                this.flatPickrDate = this.dateToString(schedule.date_object);
                this.setFlatpickrMode(schedule.date_object);
                this.attendee_object = schedule.attendee_object;
            }
        },

        setFlatpickrMode(date_object) {
            if (
                date_object.type === "single" ||
                date_object.type === "unknown"
            ) {
                this.flatPickrConfig.mode = "single";
            } else if (date_object.type === "multiple") {
                this.flatPickrConfig.mode = "multiple";
            } else if (date_object.type === "period") {
                this.flatPickrConfig.mode = "range";
            }
        },

        showDatePopup() {
            this.$modal.show(
                DateModal,
                { localSchedule: this.schedule },
                {
                    adaptive: true,
                    pivotY: this.$root.isMobile ? 1 : 0.5,
                    classes: "py-30",
                    width: "720",
                    height: "auto",
                    scrollable: true
                }
            );
        },

        showParticipantsPopup() {
            this.$modal.show(
                ParticipantModal,
                { localSchedule: this.schedule },
                {
                    adaptive: true,
                    pivotY: this.$root.isMobile ? 1 : 0.5,
                    classes: "py-30",
                    width: "720",
                    height: "auto",
                    scrollable: true
                }
            );
        },

        showLocationPopup() {
            this.$modal.show(
                LocationModal,
                {
                    localSchedule: this.schedule,
                    locations: this.items.location.map(l => l.post_title)
                },
                {
                    adaptive: true,
                    pivotY: this.$root.isMobile ? 1 : 0.5,
                    classes: "py-30",
                    width: "720",
                    height: "auto",
                    scrollable: true
                }
            );
        },

        dateUpdate() {
            let dateString = this.flatPickrDate;
            let date_object = new Object();
            date_object.data = new Object();

            if (dateString.includes(" tot ")) {
                date_object.type = "period";

                let dateArray = dateString.split(" tot ");
                date_object.data.start = dateArray[0];
                date_object.data.end = dateArray[1];
            } else {
                let dateArray = dateString.split(", ");

                if (dateString == "" || dateArray.length === 0) {
                    date_object.type = "unknown";
                } else if (dateArray.length === 1) {
                    date_object.type = "single";
                    date_object.data.date = dateArray[0];
                } else if (dateArray.length > 1) {
                    date_object.type = "multiple";
                    date_object.data.dates = dateArray;
                }
            }

            this.$store.dispatch("dayConfigurator/setDateObject", date_object);

            this.validateForm();
        },

        attendeeUpdate() {
            this.$store.dispatch(
                "dayConfigurator/setAttendeeObject",
                cloneDeep(this.attendee_object)
            );

            this.validateForm();
        },

        locationUpdate() {
            this.$store.dispatch("dayConfigurator/setlocationData", {
                location: this.location,
                location_type: this.location_type,
                radius: this.location_type === "WORDPRESS" ? null : this.radius
            });

            this.validateForm();
        },

        dateToString(date_object) {
            let dateString = "";

            if (date_object == null || date_object.type === "unknown") {
                dateString = "";
            } else if (date_object.type === "single") {
                dateString = date_object.data.date;
            } else if (date_object.type === "multiple") {
                dateString = date_object.data.dates.join(", ");
            } else if (date_object.type === "period") {
                dateString = `${date_object.data.start} tot ${date_object.data.end}`;
            }

            return dateString;
        },

        getAddressData: function(addressData, placeResultData, id) {
            bus.$emit("addressUpdate", placeResultData.name);
            this.location = placeResultData.place_id;
            this.validateAddress();
        },

        validateAddress: function(payload) {
            if (payload != null && payload == "") this.location = null;
            this.$refs.location.validate(this.location);
        },

        increaseParticipants() {
            this.attendee_object.data.amount++;
            this.attendeeUpdate();
        },

        decreaseParticipants() {
            if (this.attendee_object.data.amount > 1)
                this.attendee_object.data.amount--;
            this.attendeeUpdate();
        },

        submit() {
            this.$emit("next-step");

            if (this.schedule.id != null) {
                this.$store.dispatch("dayConfigurator/update", {
                    schedule: this.schedule,
                    set: false
                });
            } else {
                this.$store
                    .dispatch("dayConfigurator/create", this.schedule)
                    .then(() => {
                        if (history.pushState) {
                            history.pushState(
                                {},
                                null,
                                route("nl.day-configurator", [
                                    this.$store.getters[
                                        "dayConfigurator/schedule"
                                    ].id
                                ])
                            );
                        }
                    });
            }
        },

        validateForm() {
            if (
                this.schedule.date_object != null &&
                this.schedule.location != null &&
                this.schedule.location_type != null &&
                this.schedule.attendee_object != null
            ) {
                this.submit();
            }
        },

        back() {
            this.$emit("previous-step");
        }
    },

    computed: {
        dateMode() {
            if (this.schedule.date_object != null) {
                switch (this.schedule.date_object.type) {
                    case "multiple":
                        return this.translations.practical_details
                            .multiple_dates;
                    case "period":
                        return this.translations.practical_details.date_period;
                    case "unknown":
                        return this.translations.practical_details.unknown_date;
                }
            }
            return "";
        }
    },

    watch: {
        location() {
            this.$store.dispatch("dayConfigurator/setLocation", this.location);

            if (this.location_type === "WORDPRESS") {
                bus.$emit("addressUpdate", this.location);
            }

            this.validateForm();
        },

        radius() {
            this.$store.dispatch("dayConfigurator/setRadius", this.radius);
            this.validateForm();
        }
    }
};
</script>
